import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';

interface IpResponse {
  ip: string;
}

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  constructor(private readonly http: HttpClient) {}

  getTrackingInfo() {
    return this.http.get<IpResponse>('http://api.ipify.org/?format=json').pipe(
      map((res: IpResponse) => {
        const device = this.getDeviceInfo();
        return { ip: res.ip, device };
      })
    );
  }

  getDeviceInfo() {
    const ua = navigator?.userAgent;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {
      return 'MOVIL';
    } else {
      return 'PC';
    }
  }
}
